module.exports = __webpack_public_path__ + "img/putao.b7ea9f13.jpeg";